export enum StepType {
  ImportantInformation,
  YourProfile,
  AccountSecurity
}
